import React from 'react'

const Feedback = ({ content }) => {
  return (
    <p className="leading-relaxed font-light">
      &ldquo;{content}&rdquo;
    </p>
  )
}

export default Feedback
